import { AppThunk } from '../../../store/rootReducer';
import { trackDeleteWave } from '../../analytics/thunks/track-delete-wave.thunk';
import { createModeSelector } from '../selectors/create.selectors';
import { waveForIdSelector } from '../selectors/wave.selectors';
import { WaveId } from '../types/wave.type';
import { CreateMode } from '../utils/create.utils';
import { deleteWaves } from './delete-waves.thunk';
import { selectWavesInRange } from './select-wave-in-range.thunk';
import { toggleWaves } from './toggle-waves.thunk';

export const clickWave =
  (waveId: WaveId, shiftKey: boolean, ctrlKey: boolean): AppThunk<boolean> =>
  (dispatch, getState) => {
    const createMode = createModeSelector(getState());

    if (shiftKey) {
      dispatch(selectWavesInRange(waveId));
      return true;
    } else if (createMode === CreateMode.X) {
      const clickedWave = waveForIdSelector(waveId)(getState());
      if (clickedWave != null) {
        dispatch(trackDeleteWave(clickedWave, 'click'));
      }
      dispatch(deleteWaves([waveId]));
      return true;
    } else if (createMode === null) {
      dispatch(toggleWaves([waveId], { unselectOthers: !ctrlKey }));
      return true;
    } else {
      return false;
    }
  };
